import { CdkStepper } from '@angular/cdk/stepper';
import { Component } from '@angular/core';

@Component({
    selector: 'app-account-stepper',
    templateUrl: './account-stepper.component.html',
    styleUrls: ['./account-stepper.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: AccountStepperComponent }],
    standalone: false
})
export class AccountStepperComponent extends CdkStepper {
    selectStepByIndex(index: number): void {
        this.selectedIndex = index;
    }
}
